import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const MobileSuccessNow = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const orderId = searchParams.get("order_id") || "";
  const paymentKey = searchParams.get("paymentKey") || "";
  const tossOrderId = searchParams.get("orderId") || "";
  const amount = searchParams.get("amount") || "";
  const kt = searchParams.get("kt") || "";

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchResult = async () => {
      try {
        const res = await axios.get("/api/kiosk/mobile_success_now", {
          params: {
            order_id: orderId,
            paymentKey,
            orderId: tossOrderId,
            amount,
            kt,
          },
          withCredentials: true,
        });

        setData(res.data || {});
      } catch (err) {
        setData({
          ok: false,
          is_success: false,
          response_json: {
            message: err.response?.data?.message || "결제 결과를 불러오지 못했습니다.",
            code: err.response?.data?.code || "",
          },
        });
      } finally {
        setLoading(false);
      }
    };

    fetchResult();
  }, [amount, kt, orderId, paymentKey, tossOrderId]);

  if (loading) {
    return (
      <>
        <style>{`
          body { background:#f6f7f9; }
          .card { border:0; border-radius:14px; }
        `}</style>
        <div className="container py-4">
          <div className="card p-3">결제 결과를 확인하는 중...</div>
        </div>
      </>
    );
  }

  const isSuccess = Boolean(data?.is_success);
  const responseJson = data?.response_json || {};
  const newOrderId = Number(data?.new_order_id || 0);
  const isGuestOrder = Boolean(data?.is_guest_order);
  const buyerPhone = data?.buyer_phone || "";
  const ordername = data?.ordername || "";
  const totalPrice = Number(data?.total_price || 0);

  return (
    <>
      <style>{`
        body { background:#f6f7f9; }
        .card { border:0; border-radius:14px; }
      `}</style>

      <div className="container py-4">
        {isSuccess ? (
          <div className="card p-3">
            <h3 className="fw-bold mb-2">결제 성공</h3>
            <div className="text-muted small">
              주문번호: {newOrderId > 0 ? `${newOrderId}번` : "처리중"}
            </div>
            <div className="text-muted small">
              상품명: {responseJson.orderName || ordername}
            </div>
            <div className="text-muted small">
              결제수단: {responseJson.method || ""}
            </div>
            <div className="text-muted small">
              결제금액: {Number(responseJson.totalAmount || totalPrice).toLocaleString("ko-KR")}원
            </div>

            <div className="mt-3 d-grid gap-2">
              {newOrderId > 0 ? (
                isGuestOrder ? (
                  <button
                    className="btn btn-primary w-100 py-3 fw-bold mt-3"
                    onClick={() =>
                      navigate(
                        `/kiosk/guest-order-detail?order_id=${newOrderId}&phone=${encodeURIComponent(
                          buyerPhone
                        )}`
                      )
                    }
                  >
                    주문 상세
                  </button>
                ) : (
                  <button
                    className="btn btn-primary w-100 py-3 fw-bold mt-3"
                    onClick={() => navigate(`/order/detail?order_id=${newOrderId}`)}
                  >
                    주문 상세
                  </button>
                )
              ) : null}
            </div>

            <div className="text-muted small mt-3">
              {kt ? "키오스크 화면에도 결제 완료가 표시됩니다." : ""}
            </div>
          </div>
        ) : (
          <div className="card p-3">
            <h3 className="fw-bold mb-2">결제 실패</h3>
            <div className="text-danger small mb-2">
              {responseJson.message || "결제 실패"}
            </div>
            <div className="text-muted small">{responseJson.code || ""}</div>
            <div className="mt-3 d-grid gap-2">
              <button
                className="btn btn-dark"
                onClick={() => navigate(`/kiosk/mobile/cart?kt=${encodeURIComponent(kt)}`)}
              >
                장바구니로
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MobileSuccessNow;